// extracted by mini-css-extract-plugin
module.exports = {"overlay":"style_overlay__2vFhP","full":"style_full__3BmmO","unreal":"style_unreal__Fm81N","reality":"style_reality__2gT7G"};